<template>
    <div class="mm-container">
        <div class="search-add-container">
             <el-input
                style="width:30%;"
                @change="searchMem"
                placeholder="请输入搜索内容"
                prefix-icon="el-icon-search"
                v-model="searchStr">
            </el-input>
            <el-button @click="addDialog = true">添加员工</el-button>
        </div>
        <div class="title-total-container">
           <div class="bread-container">
               <h3 @click="searchStr='';getList(1);listState ='all';">润泽集团员工列表</h3>
               <div class="" v-if="listState == 'search'">>></div>
               <div class="" v-if="listState == 'search'">搜索结果</div>
           </div>
            <div>员工共计{{total}}人</div>
        </div>
            <el-table
                :data="memList"
                style="width: 100%">
                <el-table-column
                    prop="name"
                    label="姓名"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="手机号"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="status"
                    :formatter="statusFormat"
                    label="状态">
                </el-table-column>
                <el-table-column
                    prop="registertime"
                    :formatter="timeFormat"
                    label="注册时间">
                </el-table-column>
                <el-table-column
                    label="操作">
                   <template slot-scope="scope">
                        <el-button type="primary" @click="editForm = scope.row;editDialog = true;"  size="small">修改资料</el-button>
                        <el-button type="danger" size="small" @click="deleteMems(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="page"
            @current-change="handleCurrentChange"
            :total="total">
        </el-pagination>
            <el-dialog title="添加员工" :visible.sync="addDialog">
                <el-form ref="addForm" :model="addForm" :rules="rules">
                    <el-form-item label="姓名" label-width="200px"  prop="name">
                        <el-input v-model="addForm.name" auto-complete="off" placeholder="请输入姓名" style="width:60%;"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" label-width="200px"  prop="phone">
                        <el-input v-model="addForm.phone" placeholder="请输入手机号" style="width:60%;"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addMem" :loading="loading">{{submitState}}</el-button>
                    <el-button @click="addDialog = false">关闭</el-button>
                </div>
            </el-dialog>
             <el-dialog title="修改资料" :visible.sync="editDialog">
                <el-form :model="editForm">
                    <el-form-item label="姓名" label-width="200px">
                        <el-input v-model="editForm.name" auto-complete="off" placeholder="请输入姓名" style="width:60%;"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" label-width="200px">
                        <el-input v-model="editForm.phone"  placeholder="请输入手机号" style="width:60%;"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="editMem" :loading="loading">编辑</el-button>
                    <el-button @click="editDialog = false">关闭</el-button>
                </div>
            </el-dialog>
    </div>
</template>

<script>
import {getMems,addMem,editMem,deleteMem} from '@/api/manageMems'
    export default {
        name:'manage-mems',
        data() {
            return {
                listState: 'all',
                searchStr:'',
                memList:[],
                page:1,
                pageSize:10,
                addDialog:false,
                editDialog:false,
                addForm:{
                    name:'',
                    phone:'',
                    mchId:''
                },
                mchId:'',
                loading:false,
                submitState:'添加',
                total:0,
                editForm:'',
                rules: {
                    name:[{required: true,message: '请输入名称',trigger: 'blur'}],
                    phone:[
                            {required: true ,message: '请输入手机号',trigger: 'blur'},
                            { len: 11,message: '请输入正确的手机号1',trigger: 'blur'},
                            { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,message: '请输入正确的手机号2',trigger: 'blur'},
                        ]
                }
            }
            
        },
        mounted() {
            this.mchId = localStorage.mchId;
            this.getList(1);
        },
        methods: {
            getList(page) {
                this.page = page;
                getMems(this.page,this.pageSize,this.mchId,this.searchStr).then(res=>{
                    console.log(res);
                    this.memList = res.data.data;
                    this.total = res.data.count;
                }).catch(err=>{

                })
            },
            searchMem(){
                this.listState = 'search'
                this.getList(1);
            },
            handleCurrentChange(page){
                this.getList(page)
            },
            addMem(){
                this.$refs.addForm.validate((valid)=>{
                    if(valid){
                        this.addForm.mchId = this.mchId;
                        this.loading = true;
                        this.submitState = '请稍等'
                        addMem(this.addForm).then(res=>{
                            console.log(res.response);
                            if(res.response.status != 200){
                                this.$message({
                                        type: 'warn',
                                        message: res.response.data.msg
                                });
                                this.loading = false;
                                this.submitState = '请重试'
                                return;
                            }
                            this.addForm.name = ''
                            this.addForm.phone = ''
                            this.$message({
                                        type: 'success',
                                        message: '添加成功!'
                            });
                            this.loading = false;
                            this.submitState = '继续添加'
                        }).catch(error=>{
                            this.loading = false;
                            this.submitState = '请重试'
                            console.log(error);
                            // this.$message({
                            //             type: 'warn',
                            //             message: 'error!'
                            // });
                        })
                    }else{
                        return false;
                    }
                })
                
            },
            editMem(){
                editMem(this.editForm).then(res=>{
                    console.log(res);
                    this.getList(this.page);
                    this.$message({
                            type: 'success',
                            message: '修改成功!'
                    });
                    this.editDialog = false;
                    this.getList(this.page)
                })
            },
            deleteMems(data){
                let _this = this;
                this.$confirm(`删除后该员工将无法继续作为内部员工在润泽食堂进餐`, `确认删除${data.name}`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        console.log(1111);
                        deleteMem(data.id).then(res=>{
                            console.log(res);
                            _this.getList(_this.page)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }).catch(error=>{
                            this.$message({
                            type: 'info',
                            message: '出错'
                        }); 
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
               
            },
            statusFormat(row,column){
                let statusStr = row[column.property]
                let str = '';
                switch(statusStr){
                    case 0:
                        str='未激活'
                    break;
                    case 1:
                        str='激活'
                    break;
                    case 2:
                        str='停用激活'
                    break;
                    case 4:
                        str='激活'
                    break;
                }
                return str;
            },
            timeFormat(row,column){
                let timeStr = row[column.property]
                return new Date(timeStr).toLocaleString();
            }
        },
    }
</script>

<style lang="scss" scoped>
%row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.mm-container {
  width: 100%;
  height: 100%;
  .search-add-container {
    @extend %row;
    width: 100%;
    justify-content: space-between;
  }
  .title-total-container {
    @extend %row;
    justify-content: space-between;
    width: 100%;
    margin: 30px 0;
    .bread-container {
      @extend %row;
      justify-content: flex-start;
      & > h3 {
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ManageMems.vue